import axios from 'axios'

// Get show bordero fees
const get = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-bordero/${showDate}`)
  return data
}

// Update show bordero fees
const update = async (showDate, fees) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/show-bordero/${showDate}`, {
    fees
  })
  return data
}

export {
  get,
  update
}
